import { gql } from 'react-apollo';

export const deleteFaqAnswer = gql`
  mutation deleteFaqAnswer($input: DeleteFaqAnswerInput!) {
    deleteFaqAnswer(input: $input) {
      faq_answer {
        id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/faqAnswers/mutations/deleteFaqAnswer.js